// @ts-nocheck
(function () {
  'use strict';

  var EVENTS_TABLE   = 'events';
  var UNDO_WINDOW_MS = 5 * 60 * 1000; // 5 Minuten

  function boot() {
    var section = document.querySelector('[data-gb-scan]');
    if (!section) return;

    if (!window.supabase) {
      console.error('Supabase SDK not loaded');
      return;
    }

    var slug = section.dataset.restaurantSlug;
    if (!slug) {
      console.error('No restaurant slug configured');
      return;
    }
    var TICKETS_TABLE = 'tickets-' + slug;

    var sb = window.supabase.createClient(
      section.dataset.supabaseUrl,
      section.dataset.anonKey
    );

    var loginUrl    = section.dataset.loginUrl || '/pages/events-admin-login';
    var authCheck   = section.querySelector('[data-gb-auth-check]');
    var main        = section.querySelector('[data-gb-main]');
    var logoutBtn   = section.querySelector('[data-gb-logout]');
    var camToggle   = section.querySelector('[data-gb-cam-toggle]');
    var camText     = section.querySelector('[data-gb-cam-toggle-text]');
    var camPh       = section.querySelector('[data-gb-cam-placeholder]');
    var camFrame    = section.querySelector('[data-gb-frame]');
    var manualForm   = section.querySelector('[data-gb-manual-form]');
    var manualInput  = section.querySelector('#gb-scan-manual');
    var resultEl     = section.querySelector('[data-gb-result]');
    var historyWrap  = section.querySelector('[data-gb-history]');
    var historyList  = section.querySelector('[data-gb-history-list]');
    var flashEl      = section.querySelector('[data-gb-flash]');
    var modalEl      = section.querySelector('[data-gb-modal]');
    var modalOverlay = section.querySelector('[data-gb-modal-overlay]');
    var modalCloseBtn= section.querySelector('[data-gb-modal-close]');

    var qrScanner    = null;
    var camActive    = false;
    var processing   = false;
    var modalOpen    = false;
    var lastScannedCode = null;
    var lastScannedAt   = 0;
    var session      = null;

    /* ── Auth-Check ────────────────────────────────────── */

    sb.auth.getSession().then(function (res) {
      if (!res.data.session) {
        window.location.replace(loginUrl);
        return;
      }
      session = res.data.session;
      authCheck.hidden = true;
      main.hidden = false;
    }).catch(function () {
      window.location.replace(loginUrl);
    });

    /* ── Logout ────────────────────────────────────────── */

    logoutBtn.addEventListener('click', function () {
      if (qrScanner && camActive) qrScanner.stop().catch(function(){});
      sb.auth.signOut().finally(function () {
        window.location.replace(loginUrl);
      });
    });

    /* ── Kamera Toggle ─────────────────────────────────── */

    camToggle.addEventListener('click', function () {
      if (camActive) stopCamera();
      else           startCamera();
    });

    function startCamera() {
      if (!window.Html5Qrcode) {
        showToast('error', 'QR-Bibliothek konnte nicht geladen werden.');
        return;
      }
      if (!qrScanner) {
        qrScanner = new window.Html5Qrcode('gb-scan-viewport', { verbose: false });
      }
      var config = {
        fps: 10,
        qrbox: function (vw, vh) {
          var s = Math.floor(Math.min(vw, vh) * 0.7);
          return { width: s, height: s };
        },
        aspectRatio: 1.0,
      };
      qrScanner.start(
        { facingMode: 'environment' },
        config,
        onQrDetected,
        function () {} // ignore per-frame errors
      ).then(function () {
        camActive = true;
        camPh.hidden = true;
        camFrame.hidden = false;
        camText.textContent = 'Kamera stoppen';
        camToggle.classList.add('gb-scan__camera-toggle--active');
      }).catch(function (err) {
        console.error('Camera start failed:', err);
        showToast('error', 'Kamera konnte nicht gestartet werden. Berechtigung prüfen.');
      });
    }

    function stopCamera() {
      if (!qrScanner) return;
      qrScanner.stop().then(function () {
        camActive = false;
        camPh.hidden = false;
        camFrame.hidden = true;
        camText.textContent = 'Kamera starten';
        camToggle.classList.remove('gb-scan__camera-toggle--active');
      }).catch(function(){});
    }

    function onQrDetected(decodedText) {
      var code = (decodedText || '').trim();
      if (!code) return;

      // Solange Modal offen ist, neue Scans ignorieren
      if (modalOpen) return;

      // Debounce: gleicher Code innerhalb 2.5s ignorieren
      var now = Date.now();
      if (code === lastScannedCode && now - lastScannedAt < 2500) return;
      if (processing) return;
      lastScannedCode = code;
      lastScannedAt   = now;

      lookupTicket(code);
    }

    /* ── Manuelle Eingabe ──────────────────────────────── */

    manualForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = manualInput.value.trim();
      if (!code) return;
      lookupTicket(code);
      manualInput.value = '';
      manualInput.focus();
    });

    /* ── Ticket nachschlagen ───────────────────────────── */

    async function lookupTicket(code) {
      if (processing) return;
      processing = true;

      try {
        var { data: ticket, error } = await sb
          .from(TICKETS_TABLE)
          .select('*')
          .eq('verification_code', code)
          .maybeSingle();

        if (error) throw error;

        if (!ticket) {
          renderResult({ status: 'invalid', code: code });
          flash('error');
          addHistory('error', 'Ungültiger Code: ' + truncate(code));
          return;
        }

        // Event-Details laden (für Anzeige)
        var event = null;
        if (ticket.event_id) {
          var { data: ev } = await sb
            .from(EVENTS_TABLE)
            .select('id,title,date,start_time,end_time,location')
            .eq('id', ticket.event_id)
            .maybeSingle();
          event = ev;
        }

        if (ticket.redeemed_at) {
          renderResult({ status: 'redeemed', ticket: ticket, event: event });
          flash('error');
          addHistory('error', ticket.ticket_number + ' bereits eingelöst');
        } else {
          renderResult({ status: 'valid', ticket: ticket, event: event });
        }

      } catch (err) {
        console.error('Lookup failed:', err);
        showToast('error', 'Fehler beim Abrufen des Tickets.');
      } finally {
        processing = false;
      }
    }

    /* ── Ticket entwerten ──────────────────────────────── */

    async function redeemTicket(ticketId, ticketNumber) {
      processing = true;
      try {
        var redeemedBy = session && session.user ? session.user.email : null;
        var { data, error } = await sb
          .from(TICKETS_TABLE)
          .update({
            redeemed_at: new Date().toISOString(),
            redeemed_by: redeemedBy,
          })
          .eq('id', ticketId)
          .is('redeemed_at', null) // Race-Condition-Schutz
          .select()
          .maybeSingle();

        if (error) throw error;

        if (!data) {
          // Wurde zwischenzeitlich von jemand anderem entwertet
          showToast('error', 'Ticket wurde zwischenzeitlich bereits entwertet.');
          return;
        }

        // Event-Details für Anzeige nachladen
        var event = null;
        if (data.event_id) {
          var { data: ev } = await sb
            .from(EVENTS_TABLE)
            .select('id,title,date,start_time,end_time,location')
            .eq('id', data.event_id)
            .maybeSingle();
          event = ev;
        }

        renderResult({ status: 'success', ticket: data, event: event });
        flash('success');
        addHistory('success', ticketNumber + ' entwertet');

      } catch (err) {
        console.error('Redeem failed:', err);
        showToast('error', 'Entwerten fehlgeschlagen.');
      } finally {
        processing = false;
      }
    }

    /* ── Ticket entwerten rückgängig ───────────────────── */

    async function undoRedeem(ticketId, ticketNumber) {
      processing = true;
      try {
        var { data, error } = await sb
          .from(TICKETS_TABLE)
          .update({ redeemed_at: null, redeemed_by: null })
          .eq('id', ticketId)
          .select()
          .maybeSingle();

        if (error) throw error;

        // Re-render als gültig
        var event = null;
        if (data && data.event_id) {
          var { data: ev } = await sb
            .from(EVENTS_TABLE)
            .select('id,title,date,start_time,end_time,location')
            .eq('id', data.event_id)
            .maybeSingle();
          event = ev;
        }
        renderResult({ status: 'valid', ticket: data, event: event });
        addHistory('success', ticketNumber + ' wieder aktiviert');

      } catch (err) {
        console.error('Undo failed:', err);
        showToast('error', 'Rückgängigmachen fehlgeschlagen.');
      } finally {
        processing = false;
      }
    }

    /* ── Render Ergebnis ───────────────────────────────── */

    function renderResult(info) {
      if (info.status === 'invalid') {
        resultEl.innerHTML =
          '<div class="gb-scan__result gb-scan__result--invalid">' +
            '<div class="gb-scan__result-status">' +
              iconCircle('invalid') +
              '<div>' +
                '<span class="gb-scan__result-status-text">Ungültiges Ticket</span>' +
                '<span class="gb-scan__result-status-sub">Code wurde in der Datenbank nicht gefunden.</span>' +
              '</div>' +
            '</div>' +
            '<div class="gb-scan__result-grid">' +
              '<div>' +
                '<span class="gb-scan__result-field-label">Gescannter Code</span>' +
                '<span class="gb-scan__result-field-value gb-scan__result-field-value--mono">' + esc(truncate(info.code)) + '</span>' +
              '</div>' +
            '</div>' +
            '<div class="gb-scan__result-actions">' +
              '<button type="button" class="gb-scan__btn gb-scan__btn--secondary" data-gb-clear>Zurücksetzen</button>' +
            '</div>' +
          '</div>';
        bindClear();
        openModal();
        return;
      }

      var t  = info.ticket;
      var ev = info.event;
      var statusClass, statusText, statusSub;

      if (info.status === 'valid') {
        statusClass = 'valid';
        statusText  = 'Gültiges Ticket';
        statusSub   = 'Bereit zur Entwertung.';
      } else if (info.status === 'success') {
        statusClass = 'success';
        statusText  = 'Erfolgreich entwertet';
        statusSub   = 'Eintritt gewährt — willkommen!';
      } else {
        statusClass = 'redeemed';
        statusText  = 'Bereits eingelöst';
        statusSub   = t.redeemed_at ? 'Entwertet am ' + formatDateTime(t.redeemed_at) : '';
      }

      var eventBlock = ev
        ? '<div style="margin-bottom:18px">' +
            '<p class="gb-scan__result-event">' + esc(ev.title || '—') + '</p>' +
            '<p class="gb-scan__result-event-meta">' + formatEventMeta(ev) + '</p>' +
          '</div>'
        : '';

      var actions = '';
      if (info.status === 'valid') {
        actions =
          '<button type="button" class="gb-scan__btn gb-scan__btn--primary" data-gb-redeem ' +
              'data-id="' + esc(t.id) + '" data-number="' + esc(t.ticket_number) + '">' +
            'Entwerten' +
          '</button>' +
          '<button type="button" class="gb-scan__btn gb-scan__btn--secondary" data-gb-clear>Abbrechen</button>';
      } else if (info.status === 'success') {
        var canUndo = (Date.now() - new Date(t.redeemed_at).getTime()) < UNDO_WINDOW_MS;
        actions =
          '<button type="button" class="gb-scan__btn gb-scan__btn--secondary" data-gb-clear>Nächstes Ticket</button>' +
          (canUndo
            ? '<button type="button" class="gb-scan__btn gb-scan__btn--undo" data-gb-undo ' +
                  'data-id="' + esc(t.id) + '" data-number="' + esc(t.ticket_number) + '">Rückgängig</button>'
            : '');
      } else {
        actions =
          '<button type="button" class="gb-scan__btn gb-scan__btn--secondary" data-gb-clear>Zurücksetzen</button>';
      }

      resultEl.innerHTML =
        '<div class="gb-scan__result gb-scan__result--' + statusClass + '">' +
          '<div class="gb-scan__result-status">' +
            iconCircle(statusClass) +
            '<div>' +
              '<span class="gb-scan__result-status-text">' + statusText + '</span>' +
              (statusSub ? '<span class="gb-scan__result-status-sub">' + esc(statusSub) + '</span>' : '') +
            '</div>' +
          '</div>' +
          eventBlock +
          '<div class="gb-scan__result-grid">' +
            '<div>' +
              '<span class="gb-scan__result-field-label">Ticketnummer</span>' +
              '<span class="gb-scan__result-field-value gb-scan__result-field-value--mono">' + esc(t.ticket_number || '—') + '</span>' +
            '</div>' +
            '<div>' +
              '<span class="gb-scan__result-field-label">Bestellung</span>' +
              '<span class="gb-scan__result-field-value">#' + esc(t.order_number || '—') + '</span>' +
            '</div>' +
            '<div>' +
              '<span class="gb-scan__result-field-label">Teilnehmer</span>' +
              '<span class="gb-scan__result-field-value">' + esc(t.attendee_name || '—') + '</span>' +
            '</div>' +
            '<div>' +
              '<span class="gb-scan__result-field-label">E-Mail</span>' +
              '<span class="gb-scan__result-field-value">' + esc(t.attendee_email || '—') + '</span>' +
            '</div>' +
            (t.buyer_name && t.buyer_name !== t.attendee_name
              ? '<div>' +
                  '<span class="gb-scan__result-field-label">Käufer</span>' +
                  '<span class="gb-scan__result-field-value">' + esc(t.buyer_name) + '</span>' +
                '</div>'
              : '') +
            (t.redeemed_by
              ? '<div>' +
                  '<span class="gb-scan__result-field-label">Entwertet von</span>' +
                  '<span class="gb-scan__result-field-value">' + esc(t.redeemed_by) + '</span>' +
                '</div>'
              : '') +
          '</div>' +
          '<div class="gb-scan__result-actions">' + actions + '</div>' +
        '</div>';

      bindClear();
      bindRedeem();
      bindUndo();
      openModal();
    }

    function bindClear() {
      var btn = resultEl.querySelector('[data-gb-clear]');
      if (btn) btn.addEventListener('click', closeModal);
    }

    function openModal() {
      modalEl.hidden = false;
      modalOpen = true;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modalEl.hidden = true;
      modalOpen = false;
      document.body.style.overflow = '';
      resultEl.innerHTML = '';
      // Erlaubt erneutes Scannen desselben Codes
      lastScannedCode = null;
      lastScannedAt   = 0;
    }

    if (modalOverlay)  modalOverlay.addEventListener('click', closeModal);
    if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalOpen) closeModal();
    });
    function bindRedeem() {
      var btn = resultEl.querySelector('[data-gb-redeem]');
      if (btn) btn.addEventListener('click', function () {
        btn.disabled = true;
        btn.innerHTML = '<svg class="gb-scan__spinner" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.3)" stroke-width="2"/><path d="M12 2 A10 10 0 0 1 22 12" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg> Wird entwertet …';
        redeemTicket(btn.dataset.id, btn.dataset.number);
      });
    }
    function bindUndo() {
      var btn = resultEl.querySelector('[data-gb-undo]');
      if (btn) btn.addEventListener('click', function () {
        btn.disabled = true;
        undoRedeem(btn.dataset.id, btn.dataset.number);
      });
    }

    /* ── Helpers ───────────────────────────────────────── */

    function iconCircle(kind) {
      if (kind === 'valid' || kind === 'success') {
        return '<div class="gb-scan__result-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5 9-11"/></svg></div>';
      }
      if (kind === 'redeemed') {
        return '<div class="gb-scan__result-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v4M12 16h.01"/></svg></div>';
      }
      // invalid
      return '<div class="gb-scan__result-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M6 18L18 6"/></svg></div>';
    }

    function flash(kind) {
      flashEl.className = 'gb-scan__flash gb-scan__flash--show gb-scan__flash--' + kind;
      setTimeout(function () { flashEl.className = 'gb-scan__flash'; }, 500);
    }

    function showToast(kind, msg) {
      // Einfacher Inline-Status — nutzt resultEl als Anzeigefeld
      flash(kind);
      console.warn(msg);
    }

    function addHistory(kind, text) {
      historyWrap.hidden = false;
      var li = document.createElement('li');
      li.className = 'gb-scan__history-item gb-scan__history-item--' + kind;
      li.innerHTML =
        '<span>' + esc(text) + '</span>' +
        '<span class="gb-scan__history-time">' + formatTime(new Date()) + '</span>';
      historyList.insertBefore(li, historyList.firstChild);
      // Auf 20 Einträge begrenzen
      while (historyList.children.length > 20) {
        historyList.removeChild(historyList.lastChild);
      }
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function truncate(s) {
      var v = String(s || '');
      return v.length > 32 ? v.slice(0, 32) + '…' : v;
    }
    function formatDateTime(iso) {
      var d = new Date(iso);
      return d.toLocaleString('de-DE', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
      }) + ' Uhr';
    }
    function formatTime(d) {
      return d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    }
    function formatEventMeta(ev) {
      var parts = [];
      if (ev.date) {
        try {
          var d = new Date(ev.date + 'T00:00:00');
          parts.push(d.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: 'long', year: 'numeric' }));
        } catch (e) { parts.push(ev.date); }
      }
      if (ev.start_time) parts.push(ev.start_time + (ev.end_time ? '–' + ev.end_time : '') + ' Uhr');
      if (ev.location)   parts.push(ev.location);
      return esc(parts.join(' · '));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
